export default {
  default: {
    saveButtonText: 'Save & Go Back',
    title: '{integrationPlatformTitle} Quotes',
  },
}
